import { useTranslation } from "react-i18next";

export default function HRBlock() {
  const { t } = useTranslation("glas-vervangen");

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("hrBlock.h2")}
        </h2>
        <div className="flex flex-col gap-6 md:gap-8">
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("hrBlock.p1")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("hrBlock.p2")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("hrBlock.p3")}{" "}
            <a
              href="/blog/isde-subsidie-2026/"
              className="font-semibold text-brand-text underline hover:text-brand-text/70 transition-colors whitespace-nowrap"
            >
              Lees meer
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}